import { LoaderComponent } from '../shared/components/loader.component';
import { SlugifyPipe } from '../shared/pipes/slugify.pipe';
import { LoaderService } from '../shared/services/loader.service';
import { SharedModule } from '../shared/shared.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { PrivateComponent } from './private.component';
import { UsersModule } from './users/users.module';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AssociationsModule } from './associations/associations.module';
import { StudentsForImpactModule } from './students-for-impact/students-for-impact.module';
import { CitizensForImpactModule } from './citizens-for-impact/citizens-for-impact.module';
import { CagnottesModule } from './cagnottes/cagnottes.module';
import { CategoryAssociationModule } from './category-association/category-association.module';
import { PartenairesModule } from './partenaires/partenaires.module';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { DonationModule } from './donation/donation.module';
import { SubscriptionsModule } from './subscriptions/subscriptions.module';
import { DocumentsModule } from './documents/documents.module';
import { SeekersModule } from './seekers/seekers.module';
import { InvoicesModule } from './invoices/invoices.module';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    SharedModule,
    DashboardModule,
    UsersModule,
    AssociationsModule,
    StudentsForImpactModule,
    CitizensForImpactModule,
    DonationModule,
    SubscriptionsModule,
    CagnottesModule,
    PartenairesModule,
    CategoryAssociationModule,
    DocumentsModule,
    SeekersModule,
    InvoicesModule
  ],
  declarations: [PrivateComponent, LoaderComponent],
  providers: [LoaderService, SlugifyPipe],
  exports: [PrivateComponent, LoaderComponent]
})
export class PrivateModule { }
